// using module.exports here so gatsby-config can read it
module.exports = {
  // TODO: Replace next line with your own public API key
  builderAPIKey: 'f32c757c94b24306a04c53a49133c5f4'
};
